import React from 'react';

import { Container, ContainerInner } from './RoFormControl.styles';

const RoFormControl = props => {
  const { className, ...rest } = props;
  return (
    <Container {...rest}>
      <ContainerInner {...props}>{props.children}</ContainerInner>
    </Container>
  );
};

export default RoFormControl;
